import { render, staticRenderFns } from "./naoDeals.vue?vue&type=template&id=72a1f577&scoped=true&"
import script from "./naoDeals.vue?vue&type=script&lang=js&"
export * from "./naoDeals.vue?vue&type=script&lang=js&"
import style0 from "./naoDeals.vue?vue&type=style&index=0&id=72a1f577&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a1f577",
  null
  
)

export default component.exports